import { useState } from 'react';
import { ShoppingCart, Menu, Home, UtensilsCrossed } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCart } from '@/context/CartContext';
import logo from '@/assets/logo.png';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';

export function Header() {
  const { totalItems, cartBounce } = useCart();
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { to: '/', label: 'דף הבית', icon: Home },
    { to: '/meals', label: 'המנות שלנו', icon: UtensilsCrossed },
  ];

  return (
    <header className="sticky top-0 z-50 bg-card/95 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Barbor Meals" className="h-10 w-auto drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-foreground/80 hover:text-primary transition-colors font-medium"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="md:hidden">
              <button
                className="p-2 rounded-full bg-secondary hover:bg-secondary/80 transition-colors"
                aria-label="פתח תפריט"
              >
                <Menu className="h-6 w-6 text-foreground" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72">
              <SheetHeader>
                <SheetTitle className="text-right">תפריט</SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-4 mt-8">
                {navLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={() => setIsOpen(false)}
                    className="flex items-center gap-3 p-3 rounded-lg text-foreground/80 hover:text-primary hover:bg-secondary/50 transition-colors font-medium"
                  >
                    <link.icon className="h-5 w-5" />
                    {link.label}
                  </Link>
                ))}
                <Link
                  to="/cart"
                  onClick={() => setIsOpen(false)}
                  className="flex items-center gap-3 p-3 rounded-lg text-foreground/80 hover:text-primary hover:bg-secondary/50 transition-colors font-medium"
                >
                  <ShoppingCart className="h-5 w-5" />
                  סל קניות
                  {totalItems > 0 && (
                    <span className="bg-primary text-primary-foreground text-xs font-bold px-2 py-0.5 rounded-full ms-auto">
                      {totalItems}
                    </span>
                  )}
                </Link>
              </nav>
            </SheetContent>
          </Sheet>

          {/* Cart Button */}
          <Link
            to="/cart"
            aria-label="סל קניות"
            className="relative p-2 rounded-full bg-secondary hover:bg-secondary/80 transition-colors"
          >
            <ShoppingCart className="h-6 w-6 text-foreground" />
            {totalItems > 0 && (
              <span
                className={`absolute -top-1 -start-1 bg-primary text-primary-foreground text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center ${
                  cartBounce ? 'animate-cart-bounce' : 'animate-scale-in'
                }`}
              >
                {totalItems}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}
